import { UserProvider } from './user.provider';

export const AllProviders = [UserProvider];
